// Сообщение при попытке удаления профиля с активными сессиями/платежами
export const PATIENT_DELETE_BLOCKED_MESSAGE =
  'Профиль удалить невозможно, у клиента есть забронированные сессии или платежи.';
